// extracted by mini-css-extract-plugin
export default {"notification":"ExternalUserTip_notification__jTcUI"};